import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import { mCNPJ } from '../utils/masks'
import FooterDelphus from '../components/FooterDelphus'

import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, isEmpty } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Empresas(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [comboCid, setComboCid] = useState([{ value: '', display: '' }])
  const [comboEst, setComboEst] = useState([{ value: '', display: '' }])
  const [comboAtivo, setComboAtivo] = useState([{ value: 'S', display: 'Ativos' }, { value: 'N', display: 'Inativos' }])
  const [comboBloq, setComboBloq] = useState([{ value: 'S', display: 'Sim' }, { value: 'N', display: 'Não' }])

  const columns = [
    { id: 'pk_emp', numeric: false, label: 'Código', align: 'left', minWidth: 50 },
    { id: 'cnpj', cnpj: true, numeric: false, label: 'CNPJ', align: 'left', minWidth: 100, cnpj: true },
    { id: 'razao_social', numeric: false, label: 'Razão Social', align: 'left', minWidth: 150 },
    { id: 'nome_fantasia', numeric: false, label: 'Nome Fantasia', align: 'left', minWidth: 100 },
    { id: 'nomecid', numeric: false, label: 'Cidade', align: 'left', minWidth: 200 },
  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({

        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      setComboCid(await api.getComboData('cidades'))
      setComboEst(await api.getComboData('estados'))


      let Tela = 'Empresas'
      setenableAdd(await api.getAcessos(Tela, 'Inclusao'))
      setenableEdit(await api.getAcessos(Tela, 'Alteracao'))
      setenableDel(await api.getAcessos(Tela, 'Exclusao'))


      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])


  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    if (!isEmpty(queryObject)) {
      queryObject.buscar = true
      setFiltered(true)
      if (!props.modal) {
        window.history.replaceState({ filtered: true }, 'filter', "/salute/empresas?" + objectToQueryString(queryObject));
      }
      swal.fire({

        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.get('/empresas', { params: queryObject }).then(r => {
        setData(r.data)
        swal.close()
      })
    } else {
      swal.fire({
        title: 'Nenhum filtro informado!',
        html: '<p>Informe ao menos um filtro para realizar a busca.',
        icon: 'warning'
      })
    }
  }

  function clearForm(e) {
    e.preventDefault();
    if (!props.modal) {
      window.history.replaceState({ filtered: false }, 'filter', '/salute/empresas');
      document.getElementById('searchForm').reset()
    }
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    switch (e.target.name) {
      case 'cnpj': auxValues.cpf = String(mCNPJ(e.target.value))

      default: auxValues[e.target.name] = e.target.value;
    }

    setFilter(auxValues);
  };

  return (
    <div className="Manut">
      {!props.modal ? <NavBar /> : <></>}
      <div className={props.modal ? "ManutContentModal" : "ManutContent"}>
        <div className="defaultHeader">
          <h3>Empresas</h3>
          {!props.modal ? <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} /> : <></>}
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>

              <FrTextInput
                maxLength='10'
                value={filter.pk_emp || ''}
                onChange={handleChange}
                name="pk_emp"
                id="pk_emp"
                color="#389492"
                label="Código"
                variant="outlined"
                size="small"
                style={{ width: 100 }}
              />


              <FrTextInput
                maxLength='100'
                value={filter.razao_social || ''}
                onChange={handleChange}
                name="razao_social"
                id="razao_social"
                color="#389492"
                label="Razão Social"
                variant="outlined"
                size="small"
                style={{ width: 300 }}
              />

              <FrTextInput
                maxLength='20'
                value={filter.cnpj ? mCNPJ(filter.cnpj) : ''}
                onChange={handleChange}
                name="cnpj"
                id="cnpj"
                color="#389492"
                label="CNPJ"
                variant="outlined"
                size="small"
                style={{ width: 160 }}
              />
              <FrTextInput
                maxLength='100'
                value={filter.nome_fantasia || ''}
                onChange={handleChange}
                name="nome_fantasia"
                id="nome_fantasia"
                color="#389492"
                label="Nome Fantasia"
                variant="outlined"
                size="small"
                style={{ width: 300 }}
              />
              <br />

              <FrSelect
                value={filter.fk_cid || -1}
                onChange={handleChange}
                name="fk_cid"
                id="fk_cid"
                label='Cidade'
                data={comboCid}
                style={{ width: 250 }}
                mostraTodos
              />

              <FrSelect
                value={filter.fk_est || -1}
                onChange={handleChange}
                name="fk_est"
                id="fk_est"
                label='Estado'
                data={comboEst}
                style={{ width: 200 }}
                mostraTodos
              />

              <FrSelect
                value={filter.ativo || -1}
                onChange={handleChange}
                name="ativo"
                id="ativo"
                label='Situação'
                data={comboAtivo}
                style={{ width: 150 }}
                mostraTodos
              />

              <FrSelect
                value={filter.bloqueada || -1}
                onChange={handleChange}
                name="bloqueada"
                id="bloqueada"
                label='Bloqueado'
                data={comboBloq}
                style={{ width: 150 }}
                mostraTodos
              />



            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>

              {enableAdd == 'S' ?
                <Link to="/salute/empresas/registro">
                  <button >
                    <Icon icon={ic_add_box} size={18} />
                    Novo Registro
                  </button>
                </Link>
                : <></>
              }

            </div>
          </form>
        </div>
        <br />
        <div className="tableDiv">
          <FrTable width={140} ctr={'/salute/contas_receber?'} pdf={'/salute/contratos_empresas?fk_emp='} historicos={true} regName="empresas" columns={columns} searched={filtered} codeName="pk_emp" page={'empresas'} data={data} enableEdit={enableEdit} enableDel={enableDel} />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Empresas;
